import { IncomingOrderContent, IncomingTransactionOrder } from '@ui/src';
import { useAppSelector } from '@store';

const ProblemIncomingOrderContentHOC = (): React.JSX.Element => {
  const { transaction } = useAppSelector(
    (state) => state.customersProblemTransactions.incoming,
  );

  return (
    <IncomingOrderContent
      isLoading={false}
      order={transaction as IncomingTransactionOrder}
      paymentType={transaction?.paymentType}
    />
  );
};

export default ProblemIncomingOrderContentHOC;
